import React, { useState,useEffect } from "react";
import * as Yup from "yup";
import { Row, Col } from "react-bootstrap";
import InputField from "../InputField/InputField";
import CheckboxField from "../CheckboxField/CheckboxField";
import SlectInputField from "../SlectInputField";
import { Formik, Field } from "formik";
import "./ProfileInformation.styles.css";
import ChangePassword from "../ChangePassword";
import Axios from '../../lib/axios/axiosInstance';
import * as AuthVerify from '../../lib/common';
import { Flip, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userRegistration , commonPost, commonGet} from "../../services/auth";
import CustomDateTimePicker from '../InputField/CustomDateTimePicker';

const CorporateformSchema = Yup.object().shape({
  fName: Yup.string().min(2).max(25).required("First name is required"),
  lName: Yup.string().min(2).max(25).required("Last name is required"),
  // email: Yup.string().email("Email is invalid").required("Email is required"),
  gender: Yup.string().required(),
  dob: Yup.date().required("Date of birth is required"),
  addr1: Yup.string(),//.required("Address is required"),
  addr2: Yup.string(),//.required("Address is required"),
  country: Yup.string().required("Country is required"),
  // state: Yup.string().required("State is required"),
  // city: Yup.string().required("City is required"),
  zipCode: Yup.number().required("Please enter your zip Code"),
  contactNo: Yup.string().min(8).required("Please enter your contact number"),
  // confirmationBox: Yup.bool().oneOf(
  //   [true],
  //   "Subscribe to our newsletters"
  // ),
});

const ProfileInformation = () => {

  const [logedInUser, setLogedInUser] = useState(false);
  const [acccountDetails, setacccountDetails] = useState(false);
  const [dob, setDob] = useState(null);

  const getAccountDetails= async (userEmail, role) => {
    await Axios.get('/profile/userprofile?username='+userEmail)
    .then(function (response) {
    if(response.data && response.data.profile){
      response.data.profile.role=role;
        setacccountDetails(response.data.profile);
    }else{
      toast.error('Profile data fetching failed !', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Flip,
      })
    }
  })
    .catch(function (error) {
      setacccountDetails(false);
    });
};

  useEffect(() => {
    const user=AuthVerify.getUser();
    if(user && user.role){
      getAccountDetails(user.email,user.role);
      setLogedInUser(user.role);
    }
  }, [])

  useEffect(() => {
    // if(acccountDetails){
      setInitialValue({
        email: acccountDetails.email ?? '',
        fName: acccountDetails.firstname ?? '',
        lName: acccountDetails.lastname ?? '',
        uName: acccountDetails.username ?? '',
        arname: acccountDetails.arname ?? "",
        gender: acccountDetails.gender=="M"?"Male":"Female",
        dob: acccountDetails.dob,
        addr1: acccountDetails.addr1??"",
        addr2: acccountDetails.addr2??"",
        addr3: acccountDetails.addr3??"",
        country: acccountDetails.country??"",
        city: acccountDetails.city??"",
        state: acccountDetails.state??"",
        zipCode: acccountDetails.postcode??"",
        contactNo: acccountDetails.mobile ?? "",
        confirmationBox: false,
      });
      if(acccountDetails.dob)setDob(new Date(acccountDetails.dob))
      setCountryValue(acccountDetails.country);
      setStateValue(acccountDetails.state);
      setCityValue(acccountDetails.city);
    // }
  }, [acccountDetails])

  const [initialValue, setInitialValue] = useState();
  const stateName = [
    { label: "Central", value: "Central" },
    { label: "Illinois", value: "Illinois" },
    { label: "Kansas", value: "Kansas" },
  ];
  const countryName = [
    { label: "Singapore", value: "Singapore" },
    { label: "Australia", value: "Australia" },
    { label: "Austria", value: "Austria" },
    { label: "Argentina", value: "Argentina" },
    { label: "Canada", value: "Canada" },
  ];

  const updateFormSubmitHandler = async (values) => {
    const val = {
      profile:{
        username: values.uName,
        firstname: values.fName,
        lastname: values.lName,
        arname: values.arname,
        email: values.email,
        gender: values.gender.substring(0,1),
        dob: dob,
        addr1: values.addr1,
        addr2: values.addr2,
        addr3: values.addr3,
        country: values.country,
        state: values.state,
        city: values.city,
        postcode: values.zipCode.toString(),
        mobile: values.contactNo
      }
    }
    await Axios.post('/profile/userprofile/update',val)
    .then(function (response) {
      if (response && response.status == 200 && response.data.profile!=null) {
        toast.success('Profile updated successfully.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    })
  };
  toast.configure();

  //--------------------------------
  
  const [countries, setCountries] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [countryValue, setCountryValue] = useState('');
  const [allStates, setAllStates] = useState([]);
  const [states, setStates] = useState([]);
  const [stateValue, setStateValue] = useState('');
  const [cityValue, setCityValue] = useState('');
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [defaultValue, setDefaultValue] = useState(true);

  const getCountries = async () => {
    var allCountries = await commonGet(null,`https://devb2b.bizpoint-intl.com:3082/api/sysvar/countryList`,true);
    var dd=[];
    setAllCountries(allCountries.data?.countryList);
    allCountries.data.countryList.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varname})
    });
    setCountries(dd);
  };

  async function handleCountryChange(event){
    var result=allCountries.filter(x=>x.grp.varname==event.target.value)[0];
    var dd=[];
    if(result?.subgrp?.length>0){
      setAllStates(result.subgrp);
      result.subgrp.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varname})
     });
    }
    setStates(dd);
    setCities([]);
    setCountryValue(countries.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleStateChange(event){
    var result=allStates.filter(x=>x.grp.varname==event.target.value)[0];
    var dd=[];
    setAllCities(result);
    result.subgrp.forEach(element => {
      dd.push({ label: element.grp.varname, value:  element.grp.varname})
    });
    setCities(dd);
    setStateValue(states.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleCityChange(event){
    setCityValue(cities.filter(x=>x.value==event.target.value)[0]?.label);
  }

  useEffect(async () => {
    getCountries();
  }, [])

  useEffect(async () => {
    if(countryValue && defaultValue && allCountries.length>0){
      handleCountryChange({target:{value:countryValue}});
    }
  }, [allCountries,countryValue])

  useEffect(async () => {
    if(stateValue && defaultValue && allStates.length>0){
      handleStateChange({target:{value:stateValue}});
      setDefaultValue(false);
    }
  }, [allStates,stateValue])
  //--------------------------------

  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Profile</h2>
        </div>
        {logedInUser &&
          <div className="dashboard">
            <div className="welcome-msg">

              {/* <h4>Edit Profile</h4> */}
              <p>
                Please ensure your details are complete and accurate. Your profile
                details will be used as your default billing information on
                checkout process.
              </p>
            </div>
            <hr />
            <div className="page-content checkout-page">
              <h3 className="checkout-sep">Profile Information</h3>
              <div className="box-border">
                <Formik
                  initialValues={initialValue}
                  validationSchema={CorporateformSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    // console.log(values);
                    updateFormSubmitHandler(values);
                    setSubmitting(false);
                  }}
                  enableReinitialize
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Col xl={12} sm={12} xs={12}>
                        <Row>
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="fName"
                                id="fName"
                                Labels="First Name"
                                Type="text"
                                value={values.fName}
                                onChange={handleChange}
                                isInvalid={!!errors.fName}
                                className={(errors.fName && touched.fName) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>

                            <Col xl={6} sm={6}>
                              <InputField
                                Name="lName"
                                id="lName"
                                Labels="Last Name"
                                Type="text"
                                value={values.lName}
                                onChange={handleChange}
                                isInvalid={!!errors.lName}
                                className={(errors.lName && touched.lName) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col xl={12} sm={12} xs={12}>
                        <Row>

                          <Col xl={6} sm={6}>
                            <label>Gender</label>
                            <br />
                            <label style={{ paddingRight: "5px" }}>
                              <input
                                type="radio"
                                name="gender"
                                value="Male"
                                checked={values.gender === "Male"}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              Male
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="gender"
                                value="Female"
                                checked={values.gender === "Female"}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              Female
                            </label>
                            {errors.gender && touched.gender ? (
                              <>
                                <span
                                  style={{
                                    color: "red",
                                    paddingLeft: "20px",
                                  }}
                                >
                                  {" ! "} {errors.gender}{" "}
                                </span>
                                <br />
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                        </Col>
                        <Col xl={12} sm={12} xs={12}>
                          <Row>
                            <Col xl={6} sm={6}>
                              {/* <InputField
                                Name="dob"
                                id="dob"
                                Labels="Date of Birth"
                                Type="date"
                                value={values.dob}
                                onChange={handleChange}
                                isInvalid={!!errors.dob}
                                className={(errors.dob && touched.dob) ? 'is-invalid' : 'form-control'}
                              /> */}
                              <CustomDateTimePicker 
                                  Labels="Date of Birth"
                                  startYear={1970}
                                  value={new Date(dob)}
                                  onChange={(e)=>{handleChange({type:"change",target:{value:e}}); setDob(e);}}
                                  className={(errors.dob && touched.dob ) ? 'is-invalid' : 'form-control'}
                                />
                            </Col>
                              <Col xl={6} sm={6}>
                                <InputField
                                  Name="addr1"
                                  id="addr1"
                                  Labels="Address"
                                  Type="text"
                                  value={values.addr1}
                                  onChange={handleChange}
                                  isInvalid={!!errors.addr1}
                                  className={(errors.addr1 && touched.addr1) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                          </Row>
                        </Col>
                        <Col xl={12} sm={12} xs={12}>
                        <Row>
                              <Col xl={6} sm={6}>
                                <InputField
                                  Name="addr2"
                                  id="addr2"
                                  Labels="Address 2"
                                  Type="text"
                                  value={values.addr2}
                                  onChange={handleChange}
                                  isInvalid={!!errors.addr2}
                                  className={(errors.addr2 && touched.addr2) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                              <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="Country"
                                    Name="country"
                                    placeHolder="Select Your Country"
                                    options={countries}
                                    value={values.country}
                                    onChange={e=>{values.state=""; setStates([]); values.city=""; setCities([]); handleCountryChange(e); handleChange(e); }}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.country && touched.country
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col>
                              </Row>
                        </Col>

                        {/* <Col xl={12} sm={12} xs={12}>
                        <Row>
                              <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="State/Province"
                                    Type="text"
                                    Name="state"
                                    placeHolder="Select Your State"
                                    options={states}
                                    value={values.state}
                                    onChange={e=>{handleStateChange(e); handleChange(e);}}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.state && touched.state
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col>
                              <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="City"
                                    Type="text"
                                    Name="city"
                                    placeHolder="Select Your City"
                                    value={values.city}
                                    onChange={e=>{handleCityChange(e); handleChange(e);}}
                                    onBlur={handleBlur}
                                    options={cities}
                                    className={
                                      errors.city && touched.city
                                        ? " is-invalid"
                                        : ""
                                    }
                                  />
                                </div>
                              </Col>
                              </Row>
                        </Col> */}
                        <Col xl={12} sm={12} xs={12}>
                        <Row>
                              <Col xl={6} sm={6}>
                                <InputField
                                  Name="zipCode"
                                  id="address"
                                  Labels="Zip/Postal Code"
                                  Type="number"
                                  value={values.zipCode}
                                  onChange={handleChange}
                                  isInvalid={!!errors.zipCode}
                                  className={(errors.zipCode && touched.zipCode) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                          <Col xl={6} sm={6}>
                            <InputField
                              Name="contactNo"
                              id="contactNo"
                              Labels="Contact No."
                              Type="text"
                              value={values.contactNo}
                              onChange={handleChange}
                              isInvalid={!!errors.contactNo}
                              className={(errors.contactNo && touched.contactNo) ? 'is-invalid' : 'form-control'}
                            />
                          </Col>
                          </Row>
                        </Col>
                          <Col xl={12} sm={12}>
                            <Field type="checkbox" name="confirmationBox" />
                            {"  "}
                            {errors.confirmationBox &&
                              touched.confirmationBox ? (
                              <>
                                <span style={{ color: "red" }}>
                                  {" ! "} {errors.confirmationBox}{" "}
                                </span>
                                <br />
                              </>
                            ) : (
                              ""
                            )}
                            <label for="p1">
                              <span className="button"></span>
                              <strong> SUBSCRIBE TO OUR NEWSLETTER</strong>
                            </label>
                            <br />
                            <small>
                              Be the first to receive exclusive offers and the
                              latest news on our products and services directly in
                              your inbox. You may unsubscribe any time.
                            </small>
                          </Col>
                          <Col xl={12} sm={12}>
                            <button type="submit" disabled={isSubmitting} className="button">Update Profile</button>
                          </Col>
                        {/* </Row>
                      </Col> */}
                    </form>
                  )}
                </Formik>
              </div>

              <hr />
              <ChangePassword />

              {/* <h3 className="checkout-sep">Change Password</h3>
              <div className="box-border">
                <ul>
                  <li className="row">
                    <div className="col-sm-6">
                      <input
                        type="text"
                        name=""
                        className="input form-control"
                        id="last_name"
                        placeholder="Current Password"
                      />

                      <input
                        type="text"
                        name=""
                        className="input form-control"
                        id="company_name"
                        placeholder="New Password"
                      />

                      <input
                        type="text"
                        className="input form-control"
                        name=""
                        id="email_address"
                        placeholder="Confirm Password"
                      />
                    </div>
                  </li>
                </ul>
                <button className="button">Update Password</button>
              </div> */}
            </div>
          </div>
        }
        <hr />
      </div>
    </div>
  );
};

export default ProfileInformation;
